module.exports = __webpack_public_path__ + "static/media/ipad_light.48032a51.svg";